import { createAsyncThunk } from "@reduxjs/toolkit";
// eslint-disable-next-line no-unused-vars
import { fetchData } from "../../../services/apiService";
import { localDayStartToUtcDate } from "../../../services/dateUtils";
import { showSnackbar } from "../../../components/snackbar/Snackbar.slice";

const MONTHLY_REPORT_GENERATE = "monthlyReport/generateReport";

/**
 * MOCK DATA FOR TESTING
 *
 * To test different user types, change the mockReportData assignment at the bottom
 * of this file to one of:
 * - mockReportDataAcquirer (default)
 * - mockReportDataISO
 * - mockReportDataMerchant
 * - mockReportDataAdmin
 *
 * TODO: Remove all mock data and uncomment API call when connecting to backend
 */

// Mock data for testing - Change userType in generateMonthlyReport to test different types
// TODO: Remove these mocks when connecting to real API

const mockReportDataAcquirer = {
  userType: "acquirer",
  date: 20251001,
  acquirerID: "US03",
  summary: {
    total_transaction_amount: "150000.00",
    total_transaction_count: 450,
    total_fiat_tx_processing: "450.00",
    total_percent_tx_processing: "2250.00",
    total_terminal_maintenance: "500.00",
    total_terminal_setup: "200.00",
    total_monthly_amount_peer_mid: "1500.00",
    total_fees: "4900.00",
    net_amount: "145100.00",
    terminal_count: 25,
    merchant_count: 15,
  },
  commission_config: {
    fiat_tx_processing: "1.00",
    fiat_tx_processing_tiers: "0,1000,0.50",
    percent_tx_processing: "1.5",
    percent_tx_processing_tiers: "0,50000,0.75",
    fiat_terminal_maintenance: "20.00",
    fiat_terminal_maintenance_tiers: null,
    terminal_maintenance_inactive: false,
    fiat_terminal_setup: "100.00",
    fiat_terminal_setup_tiers: null,
    monthly_amount_peer_mid: "100.00",
    effective_date: "20240101",
  },
  direct_merchants: [
    {
      merchantID: "US0301",
      merchantName: "Store ABC",
      summary: {
        total_transaction_amount: "50000.00",
        total_transaction_count: 150,
        total_fiat_tx_processing: "150.00",
        total_percent_tx_processing: "750.00",
        total_terminal_maintenance: "100.00",
        total_terminal_setup: "0.00",
        total_monthly_amount_peer_mid: "100.00",
        total_fees: "1000.00",
        net_amount: "49000.00",
        terminal_count: 5,
        merchant_count: 1,
      },
    },
  ],
  isos: [
    {
      isoID: "US01",
      isoName: "ISO Alpha",
      summary: {
        total_transaction_amount: "100000.00",
        total_transaction_count: 300,
        total_fiat_tx_processing: "300.00",
        total_percent_tx_processing: "1500.00",
        total_terminal_maintenance: "400.00",
        total_terminal_setup: "200.00",
        total_monthly_amount_peer_mid: "1400.00",
        total_fees: "3800.00",
        net_amount: "96200.00",
        terminal_count: 20,
        merchant_count: 14,
      },
      merchants: [
        {
          merchantID: "US0101",
          merchantName: "Store XYZ",
          summary: {
            total_transaction_amount: "25000.00",
            total_transaction_count: 75,
            total_fiat_tx_processing: "75.00",
            total_percent_tx_processing: "375.00",
            total_terminal_maintenance: "100.00",
            total_terminal_setup: "100.00",
            total_monthly_amount_peer_mid: "100.00",
            total_fees: "650.00",
            net_amount: "24350.00",
            terminal_count: 5,
            merchant_count: 1,
          },
        },
        {
          merchantID: "US0102",
          merchantName: "Store DEF",
          summary: {
            total_transaction_amount: "75000.00",
            total_transaction_count: 225,
            total_fiat_tx_processing: "225.00",
            total_percent_tx_processing: "1125.00",
            total_terminal_maintenance: "300.00",
            total_terminal_setup: "100.00",
            total_monthly_amount_peer_mid: "1300.00",
            total_fees: "2750.00",
            net_amount: "72250.00",
            terminal_count: 15,
            merchant_count: 1,
          },
        },
      ],
    },
  ],
};

const mockReportDataAcquirer2 = {
  userType: "acquirer",
  date: 20251001,
  acquirerID: "US04",
  summary: {
    total_transaction_amount: "8510.37",
    total_transaction_count: 23,
    total_fiat_tx_processing: "1.15",
    total_percent_tx_processing: "138.29",
    total_terminal_maintenance: "0.00",
    total_terminal_setup: "0.00",
    total_monthly_amount_peer_mid: "11.00",
    total_fees: "150.44",
    net_amount: "8359.93",
    terminal_count: 5,
    merchant_count: 2,
  },
  commission_config: {
    fiat_tx_processing: "0.05",
    fiat_tx_processing_tiers: "",
    percent_tx_processing: "1.625",
    percent_tx_processing_tiers: "",
    fiat_terminal_maintenance: "0",
    fiat_terminal_maintenance_tiers: "",
    terminal_maintenance_inactive: false,
    fiat_terminal_setup: "0",
    fiat_terminal_setup_tiers: "",
    monthly_amount_peer_mid: "5.5",
    effective_date: "20250619",
  },
  direct_merchants: null,
  isos: [
    {
      isoID: "US03",
      isoName: "Merch. Industry",
      summary: {
        total_transaction_amount: "8510.37",
        total_transaction_count: 23,
        total_fiat_tx_processing: "1.15",
        total_percent_tx_processing: "138.29",
        total_terminal_maintenance: "0.00",
        total_terminal_setup: "0.00",
        total_monthly_amount_peer_mid: "11.00",
        total_fees: "150.44",
        net_amount: "8359.93",
        terminal_count: 5,
        merchant_count: 2,
      },
      merchants: [
        {
          merchantID: "M92610021296235",
          merchantName: "WEB OUTLET INC",
          summary: {
            total_transaction_amount: "8510.10",
            total_transaction_count: 17,
            total_fiat_tx_processing: "0.85",
            total_percent_tx_processing: "138.29",
            total_terminal_maintenance: "0.00",
            total_terminal_setup: "0.00",
            total_monthly_amount_peer_mid: "5.50",
            total_fees: "144.64",
            net_amount: "8365.46",
            terminal_count: 1,
            merchant_count: 1,
          },
        },
        {
          merchantID: "19101786",
          merchantName: "Blokko Holdings",
          summary: {
            total_transaction_amount: "0.27",
            total_transaction_count: 6,
            total_fiat_tx_processing: "0.30",
            total_percent_tx_processing: "0.00",
            total_terminal_maintenance: "0.00",
            total_terminal_setup: "0.00",
            total_monthly_amount_peer_mid: "5.50",
            total_fees: "5.80",
            net_amount: "-5.53",
            terminal_count: 4,
            merchant_count: 1,
          },
        },
      ],
    },
  ],
};

// eslint-disable-next-line no-unused-vars
const mockReportDataISO = {
  userType: "iso",
  date: 20251001,
  isoID: "US01",
  isoName: "ISO Alpha",
  acquirerID: "US03",
  summary: {
    total_transaction_amount: "100000.00",
    total_transaction_count: 300,
    total_fiat_tx_processing: "300.00",
    total_percent_tx_processing: "1500.00",
    total_terminal_maintenance: "400.00",
    total_terminal_setup: "200.00",
    total_monthly_amount_peer_mid: "1400.00",
    total_fees: "3800.00",
    net_amount: "96200.00",
    terminal_count: 20,
    merchant_count: 14,
  },
  commission_config: {
    fiat_tx_processing: "0.50",
    fiat_tx_processing_tiers: null,
    percent_tx_processing: "1.0",
    percent_tx_processing_tiers: null,
    fiat_terminal_maintenance: "15.00",
    fiat_terminal_maintenance_tiers: null,
    terminal_maintenance_inactive: false,
    fiat_terminal_setup: "50.00",
    fiat_terminal_setup_tiers: null,
    monthly_amount_peer_mid: "50.00",
    effective_date: "20240101",
  },
  merchants: [
    {
      merchantID: "US0101",
      merchantName: "Store XYZ",
      summary: {
        total_transaction_amount: "25000.00",
        total_transaction_count: 75,
        total_fiat_tx_processing: "75.00",
        total_percent_tx_processing: "375.00",
        total_terminal_maintenance: "100.00",
        total_terminal_setup: "100.00",
        total_monthly_amount_peer_mid: "100.00",
        total_fees: "650.00",
        net_amount: "24350.00",
        terminal_count: 5,
        merchant_count: 1,
      },
    },
    {
      merchantID: "US0102",
      merchantName: "Store DEF",
      summary: {
        total_transaction_amount: "75000.00",
        total_transaction_count: 225,
        total_fiat_tx_processing: "225.00",
        total_percent_tx_processing: "1125.00",
        total_terminal_maintenance: "300.00",
        total_terminal_setup: "100.00",
        total_monthly_amount_peer_mid: "1300.00",
        total_fees: "2750.00",
        net_amount: "72250.00",
        terminal_count: 15,
        merchant_count: 1,
      },
    },
  ],
};

// eslint-disable-next-line no-unused-vars
const mockReportDataMerchant = {
  userType: "merchant",
  date: 20251001,
  merchantID: "US0101",
  merchantName: "Store XYZ",
  isoID: "US01",
  isoName: "ISO Alpha",
  acquirerID: "US03",
  summary: {
    total_transaction_amount: "25000.00",
    total_transaction_count: 75,
    total_fiat_tx_processing: "37.50",
    total_percent_tx_processing: "250.00",
    total_terminal_maintenance: "60.00",
    total_terminal_setup: "50.00",
    total_monthly_amount_peer_mid: "50.00",
    total_fees: "447.50",
    net_amount: "24552.50",
    terminal_count: 5,
    merchant_count: 1,
  },
  commission_config: {
    amount_tx_processing: "0.50",
    amount_tx_processing_tiers: null,
    percent_tx_processing: "1.0",
    percent_tx_processing_tiers: null,
    amount_terminal_maintenance: "12.00",
    amount_terminal_maintenance_tiers: null,
    terminal_maintenance_inactive: false,
    amount_terminal_setup: "50.00",
    amount_terminal_setup_tiers: null,
    effective_date: "20240101",
  },
};

// eslint-disable-next-line no-unused-vars
const mockReportDataAdmin = {
  userType: "admin",
  date: 20251001,
  summary: {
    total_transaction_amount: "500000.00",
    total_transaction_count: 1500,
    total_fiat_tx_processing: "1500.00",
    total_percent_tx_processing: "7500.00",
    total_terminal_maintenance: "2000.00",
    total_terminal_setup: "800.00",
    total_monthly_amount_peer_mid: "5000.00",
    total_fees: "16800.00",
    net_amount: "483200.00",
    terminal_count: 100,
    merchant_count: 50,
  },
  acquirers: [
    {
      acquirerID: "US03",
      acquirerName: "Acquirer US03",
      summary: {
        total_transaction_amount: "150000.00",
        total_transaction_count: 450,
        total_fiat_tx_processing: "450.00",
        total_percent_tx_processing: "2250.00",
        total_terminal_maintenance: "500.00",
        total_terminal_setup: "200.00",
        total_monthly_amount_peer_mid: "1500.00",
        total_fees: "4900.00",
        net_amount: "145100.00",
        terminal_count: 25,
        merchant_count: 15,
      },
      commission_config: {
        fiat_tx_processing: "1.00",
        percent_tx_processing: "1.5",
        fiat_terminal_maintenance: "20.00",
        fiat_terminal_setup: "100.00",
        monthly_amount_peer_mid: "100.00",
        effective_date: "20240101",
      },
      direct_merchants: [
        {
          merchantID: "US0301",
          merchantName: "Store ABC",
          summary: {
            total_transaction_amount: "50000.00",
            total_transaction_count: 150,
            total_fees: "1000.00",
            net_amount: "49000.00",
            terminal_count: 5,
            merchant_count: 1,
          },
        },
      ],
      isos: [
        {
          isoID: "US01",
          isoName: "ISO Alpha",
          summary: {
            total_transaction_amount: "100000.00",
            total_transaction_count: 300,
            total_fees: "3800.00",
            net_amount: "96200.00",
            terminal_count: 20,
            merchant_count: 14,
          },
          merchants: [
            {
              merchantID: "US0101",
              merchantName: "Store XYZ",
              summary: {
                total_transaction_amount: "25000.00",
                total_transaction_count: 75,
                total_fees: "650.00",
                net_amount: "24350.00",
                terminal_count: 5,
                merchant_count: 1,
              },
            },
          ],
        },
      ],
    },
    {
      acquirerID: "MX01",
      acquirerName: "Acquirer MX01",
      summary: {
        total_transaction_amount: "350000.00",
        total_transaction_count: 1050,
        total_fees: "11900.00",
        net_amount: "338100.00",
        terminal_count: 75,
        merchant_count: 35,
      },
      commission_config: {
        fiat_tx_processing: "0.80",
        percent_tx_processing: "2.0",
        fiat_terminal_maintenance: "25.00",
        fiat_terminal_setup: "150.00",
        monthly_amount_peer_mid: "120.00",
        effective_date: "20240101",
      },
      direct_merchants: [],
      isos: [],
    },
  ],
};

// Default mock (change this to test different user types)
// Options: mockReportDataAcquirer, mockReportDataISO, mockReportDataMerchant, mockReportDataAdmin
// To test different types, change the assignment below:
const mockReportData = {
  acquirer: mockReportDataAcquirer2,
  iso: mockReportDataISO,
  merchant: mockReportDataMerchant,
  admin: mockReportDataAdmin,
};

export const generateMonthlyReport = createAsyncThunk(
  MONTHLY_REPORT_GENERATE,
  async (
    {
      reportDate,
      token,
      acquirerData,
      onSuccessCallback = false,
      storeAcquirerId,
      userType = "acquirer",
    },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const url = "/monthly-report";
      // const url = "/report/monthly-report";
      const dateFormatted = localDayStartToUtcDate(reportDate, "YYYYMMDD");

      const data = {
        userType,
        date: parseInt(dateFormatted, 10),
      };

      if (userType === "acquirer") {
        data.acquirerID = acquirerData.acquirerId;
      }
      if (userType === "iso") {
        data.isoID = acquirerData.isoID;
      }
      if (userType === "merchant") {
        data.merchantID = acquirerData.merchantID;
      }

      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        acquirerName: acquirerData.acquirerName,
        acquirerID: storeAcquirerId || acquirerData.acquirerId,
      };

      const response = await fetchData({
        endpoint: url,
        data,
        headers,
        token,
      });

      if (!response?.data) {
        dispatch(
          showSnackbar({
            message: "No valid data received from server",
            severity: "error",
          })
        );
        return rejectWithValue({
          message: "No valid data received from server",
        });
      }

      dispatch(
        showSnackbar({
          message: "Monthly report generated successfully!",
          severity: "success",
        })
      );

      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      dispatch(
        showSnackbar({
          message: "Monthly report generated successfully!",
          severity: "success",
        })
      );

      if (onSuccessCallback) {
        onSuccessCallback();
      }

      return response.data;
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error.message || "Error generating monthly report",
          severity: "error",
        })
      );
      return rejectWithValue({
        message: error.message || "Error generating monthly report",
      });
    }
  }
);
